import React, { useEffect, useMemo, useState } from 'react';
import { cloneDeep, set } from 'lodash';
import { useTranslation } from 'react-i18next'
// import AlarmSettings from './components/AlarmSettings_before';
import AlarmSettings from './components/AlarmSettings';
// import PatientInfoSettings from './components/PatientInfoSettings_before';
import PatientInfoSettings from './components/PatientInfoSettings';
import DisplaySettings from './components/DisplaySettings';
import OtherSettings from './components/OtherSettings';

import Confirm from './components/Patient/Confirm';
import {ReactComponent as IconClose} from '../../assets/icons/ic-close.svg'
import axios from '../../plugins/axios'
import { useRecoilState } from 'recoil';
import { wardState, monitorState } from '../../plugins/recoil';
import { activeTabStyle, inActiveTabStyle } from '../../plugins/common';

const SettingsModal = ({ initialActiveTab = 'patientInfo', onClose, handleSaveHalfDashboard, handleSaveParameter }) => {
    const { t } = useTranslation()
    const [activeTab, setActiveTab] = useState(initialActiveTab);
    const [newValue, setNewValue] = useState(null);
    const [curWard, ] = useRecoilState(wardState)
    const [wardSettings, setWardSettings] = useState(null);
    const [dashboardInfo, setDashboardInfo] = useState(null); 
    const [curMonitor] = useRecoilState(monitorState); 
    const [confirmState, setConfirmState] = useState({open : false,title : '', message : '', onYes : null , onNo : null}) // Confirm 상태 관리

    const handleSave = (newValue) => {
        setNewValue(newValue);
    };

    const handleClose = () => {
        onClose(newValue);
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case 'alarm':
                // return <AlarmSettings_before wardAlarmList={wardSettings?.wardAlarmList} defaultAlarmList={wardSettings?.defaultAlarmList} onSaveSuccess={handleSaveSuccess}/>;
                return <AlarmSettings wardSettings={wardSettings} onSaveSuccess={handleSaveSuccess} handleSaveParameter={handleSaveParameter} />;
            case 'patientInfo':                
                return <PatientInfoSettings wardSettings={wardSettings} handleSaveParameter={handleSaveParameter} handleSaveSuccess={handleSaveSuccess} handleConfirm={handleConfirm} />;
            case 'display':
                return <DisplaySettings wardSetting={wardSettings} devices={currentDevices} handleSaveHalfDashboard={handleSaveHalfDashboard} onSave={handleSave} onSaveSuccess={handleSaveSuccess} onUnassignComplete={handleUnassignComplete}/>;            
            case 'other':
                return <OtherSettings handleClose={handleClose} handleSaveParameter={handleSaveParameter}/>;
            default:
                return null;
        }
    };

    // 탭 버튼의 공통 속성
    const getTabProps = (tab) => ({
        className: `w-[200px] h-[36px] rounded-t-md ${activeTab === tab ? 'text-white' : 'text-[#CECECE] font-light'}`,
        style: activeTab === tab ? activeTabStyle : inActiveTabStyle
    });

    const fetchWardBedSettings = async () => {
        // try {
        //     // const res = await axios.post('/setup/getAllDisplay', { wardCode: curWard.value });
        //     // if (res.code !== '200') throw res;
        //     // console.log('res.result : ',res.result);

        //     //setWardSettings(res.result);
        //     setWardSettings([]);
        // } catch (err) {
        //     console.warn(err);
        // }
        try {            
            const res = await axios.get(`/ward/${curWard.value}/dashboard/settings`);
            if (res.code !== 200) throw res;
            setWardSettings(res.data); 
            // console.log('wardSettings : ', wardSettings);
        } catch (err) {
            console.warn(err);
        }
    };    

    //Confirm 창 handler
    const handleConfirm = (title, message, onYes, onNo) => {
        setConfirmState({
            open: true,
            title : title,
            message : message,
            onYes: () => {
                setConfirmState(prev => ({ ...prev, open: false })); // 모달 닫기
                if (onYes) onYes(); // 실제 onYes 실행
            },
            onNo: () => {
                setConfirmState(prev => ({ ...prev, open: false })); // 모달 닫기
                if (onNo) onNo(); // 실제 onNo 실행
            }
        });
    }

    // Tab 변경 시 Dashboard 설정 정보 가져오기.
    useEffect(() => {        
        fetchWardBedSettings();                
    }, [activeTab]);

    // curMonitor에 해당하는 devices 필터링
    const curMonitorSetting = useMemo(() => {
        if (!wardSettings || !Array.isArray(wardSettings)) return null;
        return wardSettings.find(setting => setting.displayOrder === curMonitor);
    }, [wardSettings, curMonitor]);
    
    const currentDevices = curMonitorSetting?.devices || [];

    // 저장 성공
    const handleSaveSuccess = () => {        
        fetchWardBedSettings();
        //handleSaveParameter();
    };    

    const handleUnassignComplete = () => {
        fetchWardBedSettings();
    };

    return (
        <div className="relative w-full h-full bg-black max-h-[520px] font-normal border-t border-white">
            <div className="bg-[#1F1F1F] w-full h-full">
                <div className="flex justify-between items-center h-[32px]">
                    <h2 className="text-lg font-normal text-[white] m-[6px] ml-5">{t('setting.title')}</h2>
                    <IconClose onClick={handleClose} className="m-[10px] cursor-pointer"/>
                </div>
                <div className="flex gap-1 pt-1 text-lg bg-black">
                    <button onClick={() => setActiveTab('patientInfo')} {...getTabProps('patientInfo')}>
                        {t('setting.patient')}
                    </button>
                    <button onClick={() => setActiveTab('alarm')} {...getTabProps('alarm')}>
                        {t('setting.alarm')}
                    </button>                    
                    <button onClick={() => setActiveTab('display')} {...getTabProps('display')}>
                        {t('setting.display')}
                    </button>
                    <button onClick={() => setActiveTab('other')} {...getTabProps('other')}>
                        {t('setting.other')}
                    </button>
                    {/* <button onClick={() => setActiveTab('system')} className={`w-[200px] h-[36px] rounded-t-md ${activeTab === 'system' ? 'text-white' : 'text-[#CECECE]'}`} style={{background: activeTab === 'system' ? '#1F1F1F' : 'linear-gradient(180deg, #5E5E5E 0%, #383838 100%)'}}>
                        시스템 설정
                    </button> */}
                </div>
                <div className="" style={{ height: 'calc(100% - 72px)' }}>
                    {renderTabContent()}
                </div>
            </div>

            {
                confirmState.open && <Confirm confirmState={confirmState} />   
            }            
        </div>
    );    
};


export default SettingsModal;
